import { IconButton } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * @description Renders an IconButton from the Material-UI library.
 * 
 * @author Maria Eduarda Franke
 * @param {Object} props - The props object containing the following properties:
 *   - children: The content to be rendered inside the IconButton.
 *   - onClick: The function to be called when the IconButton is clicked.
 *   - ...props: Any additional props to be passed to the IconButton component.
 * @returns {JSX.Element} The rendered IconButton component.
 */
const MyIconButton = ({ children, onClick, ...props }) => {
    return (
        <IconButton
            color='primary'
            onClick={onClick}
            {...props}
        >
            {children}
        </IconButton>
    )
}

MyIconButton.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func
}

export { MyIconButton as IconButton }
